type EthersGlobal = {
  Wallet: abstract new (...args: never[]) => unknown
  ethers?: EthersGlobal
  providers: { JsonRpcSigner: abstract new (...args: never[]) => unknown }
  utils: { arrayify: (value: string) => unknown }
}

const root = (globalThis as typeof globalThis & { ethers?: EthersGlobal }).ethers
if (!root) throw new Error('PolymarketWithdraw requires ethers v5 to be loaded first')

export const Wallet = root.Wallet
export const ethers = root.ethers || root
